import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { buildApiUrl } from '../../utils/apiUrl';

// SCSS
import '../../assets/scss/loginForm.scss';

// Images
import adrBygg from '../../assets/images/adr_bygg.jpg';

const LoginForm = () => {
	const navigate = useNavigate();
	const { login } = useAuth();

	const [userPass, setUserPass] = useState('password');
	const [mode, setMode] = useState('login');

	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [errorMessage, setErrorMessage] = useState('');

	const [loadingMessage, setLoadingMessage] = useState('');

	const showPass = (e) => {
		e.preventDefault();
		if (userPass === 'password') {
			setUserPass('text');
		} else {
			setUserPass('password');
		}
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		setErrorMessage('');
		setLoadingMessage('');

		if (mode === 'login') {
			// Use AuthContext login
			setLoadingMessage('Logger inn...');

			const result = await login({ login: username, password });

			if (result.success) {
				navigate('/');
			} else {
				setLoadingMessage('');
				setErrorMessage(result.error || 'Pålogging feilet');
			}
		} else {
			// Password reset
			try {
				const response = await fetch(buildApiUrl('auth/reset-password'), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({ username }),
					credentials: 'include',
				});

				const data = await response.json();

				if (response.ok) {
					setErrorMessage(
						data.message || 'Klikk på lenken i eposten din for å tilbakestille ditt passord.'
					);
				} else {
					setErrorMessage(data.message || 'Kunne ikke tilbakestille passord');
				}
			} catch (error) {
				console.error('Error:', error);
				setErrorMessage('Kunne ikke prosessere forespørselen');
			}
		}
	};

	return (
		<div
			className='loginForm'
			style={{ backgroundImage: `url(${adrBygg})` }}
		>
			<div className='formContainer'>
				<h2>
					{mode === 'login' ? ' Logg inn' : 'Tilbakestill passord'}
				</h2>
				<div className='form'>
					<form onSubmit={handleSubmit}>
						<div>
							<label htmlFor='emailUser'>E-post / brukernavn</label>
							<input
								type='text'
								placeholder='Epost / Brukernavn'
								name='username'
								value={username}
								onChange={(e) => setUsername(e.target.value)}
								id='emailUser'
								autoComplete={
									mode === 'login' ? 'username' : 'email'
								}
								autoCapitalize='none'
								spellCheck='false'
							/>
						</div>
						{mode === 'login' && (
							<div className='passField'>
								<label htmlFor='loginPassword'>Passord</label>
								<div className='passField-controls'>
								<input
									type={userPass}
									placeholder='*******'
									name='password'
									id='loginPassword'
									value={password}
									autoComplete='current-password'
									onChange={(e) =>
										setPassword(e.target.value)
									}
								/>
								<button
									type='button'
									onClick={showPass}
									aria-label={
										userPass === 'password'
											? 'Vis passord'
											: 'Skjul passord'
									}
								>
									{userPass === 'password' ? 'Vis' : 'Skjul'}
								</button>
								</div>
							</div>
						)}
						<input
							type='submit'
							value={
								mode === 'login'
									? 'Logg inn'
									: 'Tilbakestill passord'
							}
						/>
						<button
							type='button'
							className='forgotPass_btn'
							onClick={() =>
								setMode(
									mode === 'login'
										? 'forgotPassword'
										: 'login'
								)
							}
						>
							{mode === 'login'
								? 'Glemt passord'
								: 'Tilbake til innlogging'}
						</button>
					</form>
					{errorMessage && <p>{errorMessage}</p>}
					{loadingMessage && <p>{loadingMessage}</p>}
				</div>
			</div>
		</div>
	);
};

export default LoginForm;
